(ns frontend.view.grid.persons-grid.columns)

;;default set of selected columns
(def ordered-default-columns
  [:person/first-name
   :person/last-name
   :person/universal-email-address
   :person/universal-phone-number
   :person/tag-tags
   :person/notes
   :person/contact-owner])

(def default-columns
  (set ordered-default-columns))

;;always selected:
(def mandatory?
  #{:person/universal-email-address})
